const ClassicAccordion = {
    init() {
        const accordionButtons = document.querySelectorAll(".accordion__button");
        const accordionContents = document.querySelectorAll(".accordion__content");
        const accordionCloses = document.querySelectorAll(".accordion__close");

        if( accordionButtons ){
            accordionButtons.forEach((item) => {
                item.addEventListener("click", (event) => {
                    event.preventDefault();

                    var accordionButtonAria = event.target.getAttribute("aria-expanded");
                    // if (accordionButtons) {
                    //     accordionButtons.forEach((elementaccordionButton) => {
                    //         elementaccordionButton.classList.remove("current");
                    //         elementaccordionButton.setAttribute("aria-expanded", false);
                    //     });
                    // }

                    var contentDataId = event.target.dataset.content;
                    if (contentDataId) {
                        var contentId = document.getElementById(contentDataId);
                    }

                    if (accordionButtonAria) {
                        if (accordionButtonAria == "true") {
                            accordionButtonAria = "false";
                            event.target.classList.remove("current");
                            event.target.focus();
                            if (contentId) {
                                contentId.classList.remove("current");
                            }
                        } else {
                            accordionButtonAria = "true";
                            event.target.classList.add("current");
                            if (contentId) {
                                contentId.classList.add("current");
                                contentId.focus();
                            }
                        }
                        event.target.setAttribute("aria-expanded", accordionButtonAria);
                    }
                });
            });
        }

        if( accordionCloses ){
            accordionCloses.forEach((item) => {
                item.addEventListener("click", (event) => {
                    event.preventDefault();

                    if (accordionButtons) {
                        accordionButtons.forEach((elementaccordionButton) => {
                            elementaccordionButton.classList.remove("current");
                            elementaccordionButton.setAttribute("aria-expanded", false);
                        });
                    }

                    if (accordionContents) {
                        accordionContents.forEach((elementaccordionContent) => {
                            elementaccordionContent.classList.remove("current");
                        });
                    }
                });
            });
        }

    },
};

export default ClassicAccordion;